// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }} // column on mobile, row on tablet+
      spacing={{ xs: 2, sm: 0 }}
      sx={{
        alignItems: { xs: 'center', sm: 'center' },
        justifyContent: { xs: 'center', sm: 'space-between' },
        textAlign: { xs: 'center', sm: 'left' },
        p: '10px 24px',
        minHeight: { xs: 76, sm: 44 },
        boxSizing: 'border-box',
        flexShrink: 0,
        mt: 'auto',
        borderTop: '1px solid #e3e6f6',
        backgroundColor: '#ffffff'
      }}
    >
      {/* Left copyright text */}
      <Typography variant="caption" sx={{ color: '#504b7e', fontSize: '10.5px' }}>
        &copy; All rights reserved{' '}
        <Link href="https://injtechnologies.com/" target="_blank" underline="hover" sx={{ color: '#5b4fe0' }}>
          INJ Technologies
        </Link>
      </Typography>

      {/* Right links */}
      <Stack
        direction="row"
        flexWrap="wrap"
        justifyContent={{ xs: 'center', sm: 'flex-end' }}
        sx={{
          gap: 1.5,
          mt: { xs: 1, sm: 0 }, // margin top only on mobile
        }}
      >
        <Link
          href="https://injtechnologies.com/about-us.php"
          target="_blank"
          variant="caption"
          sx={{ color: '#504b7e', fontSize: '10.5px' }}
        >
          About us
        </Link>

        <Link
          href="https://injtechnologies.com/contact-us.php"
          target="_blank"
          variant="caption"
          sx={{ color: '#504b7e', fontSize: '10.5px' }}
        >
          Contact us
        </Link>

        <Link
          href="https://injpartners.com/privacy-policy.php"
          target="_blank"
          variant="caption"
          sx={{ color: '#504b7e', fontSize: '10.5px' }}
        >
          Privacy
        </Link>

        <Link
          href="https://injpartners.com/terms-of-use.php"
          target="_blank"
          variant="caption"
          sx={{ color: '#504b7e', fontSize: '10.5px' }}
        >
          Terms
        </Link>
      </Stack>
    </Stack>
  );
}
